var _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
export var StyledLi = styled.li(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 1.5rem;\n  border-radius: 1rem;\n  background-position: center center;\n  background-size: cover;\n  background-color: #f8f8f8;\n  box-sizing: border-box;\n",
    ]))
);
export var StyledImg = styled.img(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      "\n  width: 4.5rem;\n  height: auto;\n  right: 1rem;\n",
    ]))
);
export var StyledSpan = styled.span(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteralLoose([
      "\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  text-transform: uppercase;\n",
    ]))
);
export var StyledSpanAddress = styled.span(
  _templateObject4 ||
    (_templateObject4 = _taggedTemplateLiteralLoose([
      "\n  font-weight: 600;\n  text-transform: uppercase;\n  display: block;\n  margin: auto 0 0.5rem;\n",
    ]))
);
export var StyledP = styled.p(
  _templateObject5 ||
    (_templateObject5 = _taggedTemplateLiteralLoose([
      "\n  font-size: 0.875rem;\n  line-height: 1.166;\n  margin-bottom: 1.5rem;\n",
    ]))
);
export var StyledA = styled.a(
  _templateObject6 ||
    (_templateObject6 = _taggedTemplateLiteralLoose([
      "\n  background: linear-gradient(267.53deg, #ed1c24 -0.27%, #8820b9 100%), #c7252b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  font-style: normal;\n  font-weight: 500;\n  color: white;\n  padding: 0;\n\n  border: none;\n  cursor: pointer;\n  min-height: 1.875rem;\n  border-radius: 1.875rem;\n  padding: 0.5rem 1.25rem;\n\n  font-size: 0.75rem;\n  line-height: 1.166;\n  width: 85%;\n  border-radius: 0.3125rem;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n",
    ]))
);
export var StyledButton = styled(StyledA)(
  _templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose([""]))
);
